import { render, staticRenderFns } from "./PreMadeFilter.vue?vue&type=template&id=48c1836a&scoped=true&"
import script from "./PreMadeFilter.vue?vue&type=script&lang=js&"
export * from "./PreMadeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c1836a",
  null
  
)

export default component.exports